export const EMAIL_REGEX = /\S+@\S+\.\S+/;
export const NUMBER_REGEX = /^\d+$/;
export const FIVE_NUMBER_REGEX = /^\d{5}$/;
export const TEN_DIGIT_PHONE_NUMBER_REGEX = /^\d{10}$/;
export const NINE_DIGIT_NUMBER_REGEX = /^\d{9}$/;
export const SIX_DIGIT_OTP_CODE_REGEX = /^\d{6}$/;
export const TWO_DIGIT_CODE_REGEX =/^\d{2}$/;
export const THREE_DIGIT_CODE_REGEX = /^\d{3}$/;
export const FOUR_DIGIT_CODE_REGEX = /^\d{4}$/;
export const FLOAT_REGEX = /^[+-]?([0-9]*[.])?[0-9]+$/;
export const MINIMUM_SIX_CHARACTERS = /^.{6,}$/;
export const COUNTRY_DIAL_CODE_REGEX = /^[\d -]+$/;
export const SPACE_NOT_ALLOWED_REGEX = /^\S*$/;
export const NUMBER_SPACE_HYPHEN_ALLOWED = /^[0-9 -]+$/;
export const US_PHONE_NUMBER_REGEX = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
export const US_TAX_ID_REGEX = /^[0-9]{2}-[0-9]{7}$/;
export const ONLY_STRING = /^[a-zA-Z]+$/;

